'use client';

import React from 'react';

interface ProgressRingProps {
  pct: number;
  weeksComplete: number;
}

export default function ProgressRing({ pct, weeksComplete }: ProgressRingProps) {
  const radius = 52;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (pct / 100) * circumference;

  return (
    <div
      style={{
        backgroundColor: 'var(--bg-card)',
        border: '1px solid var(--border)',
        borderRadius: '12px',
        padding: '24px 20px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '12px',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* Subtle glow */}
      <div
        style={{
          position: 'absolute',
          top: '-40px',
          left: '50%',
          transform: 'translateX(-50%)',
          width: '120px',
          height: '120px',
          borderRadius: '50%',
          backgroundColor: 'var(--accent-glow)',
          filter: 'blur(30px)',
          pointerEvents: 'none',
        }}
      />

      <svg width="140" height="140" viewBox="0 0 140 140" style={{ transform: 'rotate(-90deg)' }}>
        <circle
          cx="70"
          cy="70"
          r={radius}
          fill="none"
          stroke="var(--border)"
          strokeWidth="8"
        />
        <circle
          cx="70"
          cy="70"
          r={radius}
          fill="none"
          stroke="var(--accent)"
          strokeWidth="8"
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          style={{ transition: 'stroke-dashoffset 800ms ease' }}
        />
      </svg>

      <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -60%)', textAlign: 'center' }}>
        <div
          style={{
            fontFamily: 'DM Serif Display, Georgia, serif',
            fontSize: '32px',
            fontWeight: 400,
            color: 'var(--text-primary)',
            lineHeight: 1,
          }}
        >
          {pct}%
        </div>
        <div style={{ fontSize: '11px', color: 'var(--text-muted)', marginTop: '2px', fontFamily: 'IBM Plex Mono, monospace' }}>
          complete
        </div>
      </div>

      <div style={{ textAlign: 'center', marginTop: '-8px' }}>
        <div style={{ fontSize: '13px', fontWeight: 500, color: 'var(--text-secondary)' }}>
          Overall Progress
        </div>
        <div
          style={{
            fontSize: '12px',
            color: 'var(--text-muted)',
            fontFamily: 'IBM Plex Mono, monospace',
            marginTop:'4px',
          }}
        >
          {weeksComplete} / 80 weeks
        </div>
      </div>
    </div>
  );
}